import React, {Component} from 'react'
import {connect} from 'react-redux'
import WithAjax from '../common/helpers/WithAjax'
import ProfileList from '../profile-list/helpers/ProfileList'
import Table from '../../tables/reactable/DefaultTable'
import {
  PERMISSION_TALENTS_READ,
  PERMISSION_VACANCIES_READ
} from '../../constants'
import ProtectedElement from '../common/helpers/ProtectedElement'

class GridDashboard extends Component {
  constructor() {
    super()
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this)
    this.state = {
      items: [],
      itemsOffers: [],
      itemsPerPage: 5,
      openBtnVisible: true,
      openBtnLabel: 'View',
      filter: {
        CanBook: 'true'
      }
    };

    this.columns = [
      'AvatarImage',
      'SkillVendorFullName',
      'ProfileTypeLabel'
    ]

    this.columnNames = [
      '',
      'Full name',
      'Profile type'
    ]

    this.tableSortDefinition = [
      'SkillVendorFullName',
      'ProfileTypeLabel'
    ]

    this.columnsActiveOffers = [
      'Poster',
      'SkillType',
      'NumberOfCandidates',
    ]
    this.columnNamesActiveOffers = [
      '',
      'Speciality',
      'Candidates',
        ]
  }

  onChangeItemsPerPage(e) {
    e.preventDefault()
    this.setState({
      itemsPerPage: e.target.value
    })
    return false
  }

  componentDidMount() {
    let urlProfilesPending = 'profiles/pending';
    this.props.ajax.get(urlProfilesPending, true, (data) => {
      data.forEach((el, index) => {
        return data[index].NavigationParam = data[index].SkillVendorId;
      });

      this.setState({
        items: data
      })
    });

    let urlActiveOffers = 'vacancies/active';

    this.props.ajax.get(urlActiveOffers, true, (data) => {
      data.forEach((el, index) => {
        if(data[index].OfferType === 'VoiceTest') {
          data[index].NavigationParam = 'voicetests/' + data[index].Id;
        }
        else {
          data[index].NavigationParam = 'vacancies/' + data[index].Id;
        }
      });

      this.setState({
        itemsOffers: data
      })
    })
  }

  render() {
    let itemsActiveOffers = this.state.itemsOffers.map(item => {
      return Object.assign({}, item, {
        Poster: item.PosterUrl ? (<img src={item.PosterUrl} style={{width: '33.2px'}} alt="" />) : (null),
        Production: item.ProductionId ? (<a href={'/productions/' + item.ProductionId + '/overview'} title={item.Title}>{item.Title}</a>): (null),
        ProductionForSearch: item.Title,
        NumberOfCandidates: item.NumberOfCandidates ? (item.PreHiredCandidateId ? <a href={'/talents/' + item.PreHiredCandidateId + '/overview'}>{item.PreHiredCandidateFullName}</a>:<span>{item.NumberOfCandidates}</span>):(null)
      })
    });

    return (
      <div className="row">
        <ProtectedElement permission={PERMISSION_TALENTS_READ}>
          <div className="col-6 mt-3">
            <h4>Pending profiles</h4>
            <ProfileList
              columns={this.columns}
              columnNames={this.columnNames}
              items={this.state.items}
              tableSortDefinition={this.tableSortDefinition}
              itemsPerPage='5'
              hiddenSelectItemsPerPage={'true'}
            >
            </ProfileList>
          </div>
        </ProtectedElement>
        <ProtectedElement permission={PERMISSION_VACANCIES_READ}>
          <div className="col-6 mt-3">
            <h4>Active offers</h4>
            <Table
              items={itemsActiveOffers}
              columns={this.columnsActiveOffers}
              columnNames={this.columnNamesActiveOffers}
              itemsPerPage={this.state.itemsPerPage}
              onChangeItemsPerPage={this.onChangeItemsPerPage}
              openBtnVisible={this.state.openBtnVisible}
              openBtnLabel={this.state.openBtnLabel}
              openBtnHref="/{NavigationParam}/overview"
              filterable={[{
                column: 'CanBook'
              }]}
              filter={this.state.filter}
              sortable={[
                'SkillType',
                'NumberOfCandidates'
              ]}
              hiddenSelectItemsPerPage={'true'}
            />
          </div>
        </ProtectedElement>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  isLoading: state.common.isLoading
})
const mapDispatchToProps = dispatch => ({
})
export default connect(mapStateToProps, mapDispatchToProps)(WithAjax(GridDashboard))
